import React from "react";
import "./education.css";

function Education() {
  return (
    <section className="education-section">
      <div className="education-container">
        <h2 className="education-title">Education</h2>

        <div className="education-item">
          <h3 className="degree">Bachlors of Computer Science and Inovation</h3>
          <p className="university">Champlain College</p>
          <p className="graduation-date">Expected Graduation: May, 2026</p>
          <p className="courses">
            Relevant Courses: Advanced Programming, Data Structures & Algorithms, Network Programming, Database Management Systems, Computer Architecture, Discrete Mathematics, Topics in AI, Emerging Languages
          </p>
        </div>
      </div>
    </section>
  );
}

export default Education;